/* Open To Close theme script. No dependencies. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = document.documentElement;
  root.classList.replace('no-js', 'js');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const T = window.theme || {};
  const routes = T.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  /* the t filter HTML-escapes translations (park's -> park&#39;s); strings here go into textContent, so decode them */
  const unescape = (() => { const ta = document.createElement('textarea'); return s => { ta.innerHTML = s; return ta.value; }; })();
  const say = (k, d) => (T.strings && T.strings[k] && unescape(T.strings[k])) || d;

  /* money */
  function formatMoney(cents) {
    const fmt = T.moneyFormat || '${{amount}}';
    const n = Number(cents) / 100;
    const delim = (dec, t = ',', d = '.') => {
      const [i, f] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? d + f : '');
    };
    const out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: delim(2), amount_no_decimals: delim(0),
      amount_with_comma_separator: delim(2, '.', ','), amount_no_decimals_with_comma_separator: delim(0, '.', ',')
    }[k] || delim(2)));
    return out.replace(/([.,])00(?!\d)/, '');
  }

  /* toast */
  let toastTimer;
  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { t.hidden = true; }, 3400);
  }

  /* header, park clock, and the sky that follows the day */
  const hdr = $('.hdr');
  const clock = $('[data-clock]');
  function setClock(time, status, open) {
    if (!clock) return;
    $('[data-clock-time]', clock).textContent = time;
    $('[data-clock-status]', clock).textContent = status;
    clock.classList.toggle('is-closed', !open);
  }
  /* park time: the hours of the day (from collections with a Park time) and which one it is right now */
  const PARK = (() => { try { return JSON.parse(($('#ParkHours') || {}).textContent || '[]'); } catch (e) { return []; } })();
  function parkNow() {
    const d = new Date(), mins = d.getHours() * 60 + d.getMinutes();
    let idx = -1;
    PARK.forEach((h, i) => { if (mins >= h.start) idx = i; });
    return { mins, idx, hour: PARK[idx] || null, time: d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }) };
  }
  function localClock() {
    const n = parkNow();
    if (PARK.length) {
      // the clock names the hour it is in the park and links to it; before the gates open it's after hours
      setClock(n.time, n.hour ? n.hour.name : say('afterHours', 'After hours'), !!n.hour);
      if (clock && clock.tagName === 'A') clock.href = (n.hour || PARK[0]).url;
      return;
    }
    const open = n.mins >= 509 && n.mins < 1380;
    setClock(n.time, open ? say('parkOpen', 'Park open') : say('afterHours', 'After hours'), open);
  }

  let markers = [], stops = [], railPos = [], sparks = [], labs = [], nowIdx = -2, track = null, marker = null, nowEl = null, nowW = 0;
  const shown = el => el && el.getClientRects().length > 0;

  /* each hour has a spark color; the timeline sparkle blends between them in OKLab so the in-between shades stay bright */
  const hexRgb = h => { const m = /^#?([0-9a-f]{6})$/i.exec((h || '').trim()); if (!m) return null; const n = parseInt(m[1], 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; };
  const toLin = c => (c /= 255) <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  const toGam = c => 255 * (c <= 0.0031308 ? 12.92 * c : 1.055 * c ** (1 / 2.4) - 0.055);
  function toLab(hex) {
    const rgb = hexRgb(hex);
    if (!rgb) return null;
    const [r, g, b] = rgb.map(toLin);
    const l = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b), m = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b), s = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
    return [0.2104542553 * l + 0.7936177850 * m - 0.0040720468 * s, 1.9779984951 * l - 2.4285922050 * m + 0.4505937099 * s, 0.0259040371 * l + 0.7827717662 * m - 0.8086757660 * s];
  }
  function fromLab([L, A, B]) {
    const l = (L + 0.3963377774 * A + 0.2158037573 * B) ** 3, m = (L - 0.1055613458 * A - 0.0638541728 * B) ** 3, s = (L - 0.0894841775 * A - 1.2914855480 * B) ** 3;
    return '#' + [4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s, -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s, -0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s]
      .map(v => Math.round(toGam(Math.min(1, Math.max(0, v)))).toString(16).padStart(2, '0')).join('');
  }
  const hour24 = t => { const m = /(\d+)(?::\d+)*\s*(AM|PM)?/i.exec(t || ''); if (!m) return 0; let h = Number(m[1]); if (m[2]) h = h % 12 + (/pm/i.test(m[2]) ? 12 : 0); return h; };
  function initDay() {
    const hours = $$('[data-hour]');
    sparks = hours.map(h => h.dataset.spark || '');
    labs = sparks.map(toLab);
    track = $('.day__track');
    if (track) {
      track.innerHTML = '<div class="day__rail" aria-hidden="true"><i class="day__fill"></i><span class="day__marker"></span></div><span class="day__now" aria-hidden="true"></span>' +
        hours.map((h, i) => `<a class="day__stop" href="#${h.id}"${hexRgb(sparks[i]) ? ` style="--c:${sparks[i]}"` : ''}><i class="day__dot" aria-hidden="true"></i><span class="day__label"><time>${h.dataset.time}</time><b>${h.dataset.label}</b></span></a>`).join('');
      stops = $$('.day__stop', track);
      marker = $('.day__marker', track);
      nowEl = $('.day__now', track);
    }
    markers = [$('[data-hero]'), ...hours].filter(Boolean);
    layoutRail();
    nowIdx = -2;
    onScroll();
  }
  // stops are spread post to post, so the rail runs from the first dot to the last.
  // When the labels would run into each other, the bar shows dots only and names the current hour under the marker.
  function layoutRail() {
    if (!track || !stops.length || !shown(track)) return;
    track.classList.remove('is-compact');
    const boxes = stops.map(s => $('.day__label', s).getBoundingClientRect());
    track.classList.toggle('is-compact', boxes.some((r, i) => i > 0 && r.left < boxes[i - 1].right + 16));
    nowW = 0;
    railPos = stops.map(s => s.offsetLeft + s.offsetWidth / 2);
    const w = railPos[railPos.length - 1] - railPos[0];
    track.style.setProperty('--rail-l', railPos[0] + 'px');
    track.style.setProperty('--rail-w', w + 'px');
    // the line fills with the colors of the hours already passed
    if (w > 0 && labs.length === railPos.length && labs.every(Boolean)) track.style.setProperty('--rail-grad', `linear-gradient(90deg,${sparks.map((c, i) => `${c} ${((railPos[i] - railPos[0]) / w * 100).toFixed(2)}%`).join(',')})`);
  }
  function onScroll() {
    if (hdr) hdr.classList.toggle('is-solid', scrollY > 8 || !shown($('[data-hero]')));
    const live = markers.filter(shown);
    if (!live.length) {
      if (nowIdx !== -3) { nowIdx = -3; root.style.removeProperty('--now-sky'); root.style.removeProperty('--now-ink'); localClock(); }
      return;
    }
    const line = (hdr ? hdr.offsetHeight : 64) + 90;
    const hours = live.filter(x => x.hasAttribute('data-hour'));
    let idx = -1;
    live.forEach((m, i) => { const r = m.getBoundingClientRect(); if (r.top <= line && r.bottom > line) idx = i; });
    // the marker moves continuously: whole steps per hour, plus how far through the current hour you are
    let prog = 0;
    if (hours.length && hours[0].getBoundingClientRect().top <= line) {
      prog = hours.length - 1;
      for (let i = 0; i < hours.length - 1; i++) {
        const r = hours[i].getBoundingClientRect();
        if (r.top <= line && r.bottom > line) { prog = i + (line - r.top) / r.height; break; }
      }
    }
    const m = live[idx];
    const hourIdx = m && m.hasAttribute('data-hour') ? hours.indexOf(m) : -1;
    const passedAll = idx === -1 && live[live.length - 1].getBoundingClientRect().bottom <= line;
    if (idx !== nowIdx) {
      nowIdx = idx;
      if (m) { root.style.setProperty('--now-sky', m.dataset.sky); root.style.setProperty('--now-ink', m.dataset.ink); }
      else { root.style.removeProperty('--now-sky'); root.style.removeProperty('--now-ink'); }
      if (m && m.dataset.time) setClock(m.dataset.time, say('parkOpen', 'Park open'), true);
      else if (passedAll && hours.length) setClock('23:00', say('parkClosed', 'Park closed'), false);
      else localClock();
      stops.forEach((s, i) => {
        s.classList.toggle('is-past', passedAll || (hourIdx > -1 && i < hourIdx));
        s.classList.toggle('is-now', i === hourIdx);
        if (i === hourIdx) s.setAttribute('aria-current', 'step'); else s.removeAttribute('aria-current');
      });
      const cur = stops[hourIdx > -1 ? hourIdx : passedAll ? stops.length - 1 : 0];
      if (nowEl && cur) { nowEl.innerHTML = $('.day__label', cur).innerHTML; nowW = 0; }
    }
    if (track && railPos.length) {
      const i0 = Math.min(Math.floor(prog), railPos.length - 1), i1 = Math.min(i0 + 1, railPos.length - 1);
      const fill = railPos[i0] + (railPos[i1] - railPos[i0]) * (prog - i0) - railPos[0];
      track.style.setProperty('--fill', fill.toFixed(1) + 'px');
      // the sparkle spins as it travels and takes on the color of the hours around it
      track.style.setProperty('--turn', (prog * 90).toFixed(1) + 'deg');
      if (labs[i0] && labs[i1]) { const t = prog - i0; root.style.setProperty('--spark-now', fromLab(labs[i0].map((v, k) => v + (labs[i1][k] - v) * t))); }
      if (nowEl && track.classList.contains('is-compact')) {
        if (!nowW) nowW = nowEl.offsetWidth;
        const x = railPos[0] + fill - nowW / 2, min = railPos[0] - 6, max = railPos[railPos.length - 1] + 6 - nowW;
        track.style.setProperty('--now-x', Math.max(min, Math.min(max, x)).toFixed(1) + 'px');
      }
    }
  }
  let ticking = false;
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { onScroll(); ticking = false; }); } }, { passive: true });
  addEventListener('resize', () => { layoutRail(); nowIdx = -2; onScroll(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { layoutRail(); nowIdx = -2; onScroll(); });

  /* mobile menu opens below the header and stops the page scrolling behind it */
  const menu = $('.menu');
  if (menu) menu.addEventListener('toggle', () => {
    if (menu.open && hdr) root.style.setProperty('--menu-top', Math.round(hdr.getBoundingClientRect().bottom) + 'px');
    root.classList.toggle('menu-open', menu.open);
  });
  // a tap outside the open menu closes it
  document.addEventListener('click', e => { if (menu && menu.open && !menu.contains(e.target)) menu.open = false; });

  /* fireworks over the 21:00 sky. Rockets climb from the bottom of the screen and burst into peonies, rings,
     gold willows, crossettes, crackling glitter and the OTC sparkle. Tap the sky to send one up yourself. */
  function fireworks(canvas) {
    if (canvas.dataset.on) return;
    canvas.dataset.on = '1';
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const host = canvas.closest('[data-hour]') || canvas.parentElement;
    const spark = getComputedStyle(canvas).getPropertyValue('--spark').trim() || '#FF4FD8';
    const GOLD = '#FFC94A', TAU = Math.PI * 2, G = 150, LIFT = 520;
    // each shell is a main color and a second one for its core or its sub-bursts
    const SHELLS = [[spark, '#FFFFFF'], ['#7FD1F2', '#FFFFFF'], [GOLD, '#FFF2C4'], [spark, GOLD], ['#F3EEE6', spark], ['#B8F2FF', spark], ['#FF5B2E', GOLD]];
    const KINDS = ['peony', 'peony', 'sparkle', 'sparkle', 'ring', 'willow', 'crossette', 'glitter'];
    const rnd = (a, b) => a + Math.random() * (b - a);
    const pick = list => list[(Math.random() * list.length) | 0];
    let w = 0, h = 0, parts = [], rockets = [], flashes = [], queue = [], raf = 0, running = false, last = 0, next = 0, seenOnce = false;

    function size() {
      const dpr = Math.min(devicePixelRatio || 1, 1.5);
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    // the slice of the section that is on screen, so shells burst where people are looking
    function view() {
      const r = canvas.getBoundingClientRect(), top = Math.max(0, -r.top), bottom = Math.min(h, innerHeight - r.top);
      return bottom - top > 120 ? [top, bottom] : [0, h];
    }
    const add = (x, y, vx, vy, c, o = {}) => parts.push({ x, y, px: x, py: y, vx, vy, c, age: 0, life: o.life || 1.3, size: o.size || 1.7, drag: o.drag ?? 1.5, g: o.g ?? 1, trail: o.trail || 0, tt: 0, glitter: !!o.glitter, split: o.split || null, alpha: o.alpha ?? 1, thin: !!o.thin });

    function launch(x, y, kind, shell) {
      const [top, bottom] = view();
      const tx = x ?? rnd(0.14, 0.86) * w, ty = y ?? top + rnd(0.12, 0.4) * (bottom - top);
      const x0 = tx + rnd(-50, 50), y0 = bottom + 8, rise = Math.max(60, y0 - ty);
      const vy = -Math.sqrt(2 * LIFT * rise), t = -vy / LIFT;
      rockets.push({ x: x0, y: y0, vx: (tx - x0) / t, vy, kind: kind || pick(KINDS), shell: shell || pick(SHELLS), tt: 0 });
    }

    function explode(x, y, kind, shell) {
      const S = Math.min(300, Math.max(150, w * 0.2));
      const [c1, c2] = kind === 'willow' ? [GOLD, '#FFF2C4'] : shell;
      flashes.push({ x, y, r: S * rnd(0.55, 0.8), age: 0, life: 0.3 });
      const sphere = (n, speed, c, o) => {
        for (let i = 0; i < n; i++) {
          const a = rnd(0, TAU), z = rnd(-1, 1), r = Math.sqrt(1 - z * z) * speed * rnd(0.94, 1.04);
          add(x, y, Math.cos(a) * r, Math.sin(a) * r, c, o);
        }
      };
      if (kind === 'sparkle') {
        // the brand's four-point sparkle: an astroid, sampled evenly along its outline so the curves stay full
        const tilt = rnd(-0.18, 0.18), cs = Math.cos(tilt), sn = Math.sin(tilt);
        const star = (m, speed, c, o) => {
          for (let q = 0; q < 4; q++) for (let j = 0; j < m; j++) {
            const th = Math.asin(Math.sqrt((j + 0.5) / m)), ax = Math.cos(th) ** 3, ay = Math.sin(th) ** 3;
            const [px, py] = [[ax, ay], [-ay, ax], [-ax, -ay], [ay, -ax]][q];
            add(x, y, (px * cs - py * sn) * speed, (px * sn + py * cs) * speed, c, o);
          }
        };
        star(22, S * 1.1, c1, { life: rnd(1.5, 1.8), drag: 1.25, g: 0.45, size: 1.9 });
        star(9, S * 0.55, c2, { life: 1.3, drag: 1.25, g: 0.45, size: 1.6 });
      } else if (kind === 'ring') {
        const n = 56, tilt = rnd(0.32, 0.62), rot = rnd(0, TAU), cr = Math.cos(rot), sr = Math.sin(rot);
        for (let i = 0; i < n; i++) {
          const a = i / n * TAU, vx = Math.cos(a) * S, vy = Math.sin(a) * S * tilt;
          add(x, y, vx * cr - vy * sr, vx * sr + vy * cr, c1, { life: rnd(1.2, 1.5), drag: 1.3, g: 0.8, size: 1.8 });
        }
        sphere(14, S * 0.3, c2, { life: 0.9, size: 1.5 });
      } else if (kind === 'willow') {
        sphere(48, S * 0.85, c1, { life: rnd(2.4, 3), drag: 2.1, g: 0.85, size: 1.6, trail: 0.07 });
      } else if (kind === 'crossette') {
        const n = 12;
        for (let i = 0; i < n; i++) {
          const a = i / n * TAU + rnd(-0.08, 0.08);
          add(x, y, Math.cos(a) * S * 0.9, Math.sin(a) * S * 0.9, c1, { life: rnd(0.5, 0.65), drag: 1.1, g: 0.6, size: 2.2, split: c2 });
        }
      } else if (kind === 'glitter') {
        sphere(84, S * 0.8, c1, { life: rnd(1.5, 1.9), drag: 1.7, g: 1, size: 1.4, glitter: true });
      } else {
        sphere(80, S, c1, { life: rnd(1.2, 1.5), drag: 1.6, g: 1, size: 1.7 });
        sphere(20, S * 0.38, c2, { life: 1, drag: 1.6, size: 1.5 });
      }
    }

    function step(dt) {
      // fade what is already drawn, so every spark leaves a short glowing trail
      ctx.globalCompositeOperation = 'destination-out';
      ctx.globalAlpha = 1;
      ctx.fillStyle = `rgba(0,0,0,${(1 - 0.8 ** (dt * 60)).toFixed(3)})`;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      ctx.lineCap = 'round';

      for (const f of flashes) {
        f.age += dt;
        const k = 1 - f.age / f.life, g = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r);
        g.addColorStop(0, `rgba(255,236,214,${(0.16 * k).toFixed(3)})`);
        g.addColorStop(1, 'rgba(255,236,214,0)');
        ctx.globalAlpha = 1; ctx.fillStyle = g;
        ctx.fillRect(f.x - f.r, f.y - f.r, f.r * 2, f.r * 2);
      }
      flashes = flashes.filter(f => f.age < f.life);

      for (const r of rockets) {
        r.x += r.vx * dt; r.y += r.vy * dt; r.vy += LIFT * dt; r.tt += dt;
        while (r.tt > 0.016) { r.tt -= 0.016; add(r.x, r.y, rnd(-18, 18), rnd(10, 40), GOLD, { life: rnd(0.25, 0.45), drag: 3, g: 0.3, size: 1.3, alpha: 0.7, thin: true }); }
        ctx.globalAlpha = 1; ctx.fillStyle = '#FFF6E0';
        ctx.beginPath(); ctx.arc(r.x, r.y, 2, 0, TAU); ctx.fill();
        if (r.vy > -25) { r.done = true; explode(r.x, r.y, r.kind, r.shell); }
      }
      rockets = rockets.filter(r => !r.done);

      const born = [];
      for (const p of parts) {
        p.age += dt;
        const k = Math.exp(-p.drag * dt);
        p.px = p.x; p.py = p.y;
        p.vx *= k; p.vy = p.vy * k + G * p.g * dt;
        p.x += p.vx * dt; p.y += p.vy * dt;
        if (p.trail && parts.length < 1500 && (p.tt += dt) > p.trail) { p.tt = 0; born.push([p.x, p.y, p.vx * 0.05, p.vy * 0.05, p.c, { life: 0.6, drag: 2.5, g: 0.5, size: 1, alpha: 0.45, thin: true }]); }
        if (p.split && p.age >= p.life) {
          const a = Math.atan2(p.vy, p.vx);
          for (let i = 0; i < 4; i++) { const b = a + Math.PI / 4 + i * Math.PI / 2; born.push([p.x, p.y, Math.cos(b) * 95, Math.sin(b) * 95, p.split, { life: rnd(0.6, 0.85), drag: 1.4, g: 0.8, size: 1.6 }]); }
        }
        const t = p.age / p.life;
        let a = (1 - t * t) * p.alpha;
        if (p.glitter && t > 0.35) a *= Math.random() < 0.45 ? 1 : 0.12;
        if (a <= 0) continue;
        ctx.strokeStyle = p.c;
        if (!p.thin) { ctx.globalAlpha = a * 0.2; ctx.lineWidth = p.size * 3.6; ctx.beginPath(); ctx.moveTo(p.px, p.py); ctx.lineTo(p.x, p.y); ctx.stroke(); }
        ctx.globalAlpha = a; ctx.lineWidth = p.size;
        ctx.beginPath(); ctx.moveTo(p.px, p.py); ctx.lineTo(p.x, p.y); ctx.stroke();
      }
      parts = parts.filter(p => p.age < p.life);
      born.forEach(b => add(...b));
      if (!parts.length && !rockets.length && !flashes.length) ctx.clearRect(0, 0, w, h);
    }

    function frame(now) {
      const dt = Math.min(0.05, (now - last) / 1000 || 0.016);
      last = now;
      while (queue.length && queue[0].at <= now) { const q = queue.shift(); launch(q.x, q.y, q.kind); }
      if (now >= next) {
        launch();
        if (Math.random() < 0.2) launch();
        next = now + rnd(900, 2000);
      }
      step(dt);
      if (running) raf = requestAnimationFrame(frame);
    }

    size();
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(canvas); else addEventListener('resize', size);
    if (reduce) {
      // no motion: one still frame of three bursts
      [['peony', 0.25, 0.3], ['sparkle', 0.55, 0.22], ['willow', 0.8, 0.34]].forEach(([k, x, y]) => explode(w * x, h * y, k, SHELLS[0]));
      for (let i = 0; i < 40; i++) step(1 / 60);
      return;
    }
    // tap or click the sky (anywhere that isn't a link, button or card) to send a rocket there
    host.addEventListener('click', e => {
      if (!running || e.target.closest('a, button, input, select, textarea, label, summary, .card, [role="button"]')) return;
      if (String(getSelection && getSelection()).length) return;
      const r = canvas.getBoundingClientRect();
      launch(e.clientX - r.left, e.clientY - r.top);
    });
    new IntersectionObserver(([e]) => {
      running = e.isIntersecting;
      cancelAnimationFrame(raf);
      if (!running) return;
      last = performance.now();
      if (!seenOnce) {
        // an opening volley the first time the hour scrolls in, with the sparkle in the middle
        seenOnce = true;
        queue.push({ at: last + 50, x: w * 0.3, kind: 'peony' }, { at: last + 380, x: w * 0.55, kind: 'sparkle' }, { at: last + 700, x: w * 0.78, kind: 'willow' });
        next = last + 1800;
      }
      raf = requestAnimationFrame(frame);
    }).observe(canvas);
  }


  /* cart */
  const shopifyBackend = {
    async post(url, body) {
      const res = await fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: location.pathname }) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(res.status === 422 && !/cannot find/i.test(data.description || '') && data.description ? data.description : say('cartError', 'Something went wrong. Try again.'));
      return data;
    },
    add(items) { return this.post(routes.cart_add_url, { items }); },
    change(key, quantity) { return this.post(routes.cart_change_url, { id: key, quantity }); }
  };
  const backend = () => (window.OTC_PREVIEW && window.OTC_PREVIEW.backend) || shopifyBackend;
  const drawer = $('#CartDrawer');
  let lastFocus = null;
  const behindDrawer = () => $$('body > *').filter(n => drawer && !n.contains(drawer) && !n.classList.contains('drawer-scrim') && !/^(SCRIPT|STYLE|LINK)$/.test(n.tagName) && !n.classList.contains('toast'));
  function openDrawer() {
    if (!drawer) { location.href = routes.cart_url; return; }
    if (!document.body.classList.contains('drawer-open')) lastFocus = document.activeElement;
    document.body.classList.add('drawer-open');
    drawer.removeAttribute('inert'); drawer.setAttribute('aria-hidden', 'false');
    behindDrawer().forEach(n => { n.inert = true; });
    loadBagRecs();
    usDelivery();
    setTimeout(() => { const c = $('[data-drawer-close]', drawer); c && c.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer) return;
    document.body.classList.remove('drawer-open');
    drawer.setAttribute('inert', ''); drawer.setAttribute('aria-hidden', 'true');
    behindDrawer().forEach(n => { n.inert = false; });
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  function renderDrawer(html) {
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer-inner]');
    const cur = $('[data-drawer-inner]');
    if (fresh && cur) cur.replaceWith(fresh);
    const st = $('[data-cart-status]'), tot = fresh && $('.drawer__total', fresh), empty = fresh && $('.drawer__empty p', fresh);
    if (st) st.textContent = tot ? [...tot.children].map(s => s.textContent.trim()).join(' ') : empty ? empty.textContent.trim() : '';
    if (fresh) $$('[data-cart-count]').forEach(el => { el.textContent = fresh.dataset.count; el.dataset.count = fresh.dataset.count; el.dataset.dealCount = fresh.dataset.dealCount || fresh.dataset.count; });
    loadBagRecs();
    usDelivery();
    dealText();
  }

  /* the multi-buy line on product pages counts what's already in the bag */
  function dealText() {
    const c = $('[data-cart-count]'), n = c ? Number(c.dataset.dealCount != null ? c.dataset.dealCount : c.dataset.count) || 0 : 0;
    $$('[data-deal]').forEach(d => {
      const out = $('[data-deal-text]', d);
      if (!out) return;
      if (!d.dataset.base) d.dataset.base = out.textContent;
      const q = Number(d.dataset.qty) || 3, sv = d.dataset.saving || '';
      let txt = d.dataset.base;
      if (n >= q) txt = say('dealOn', txt).replace('[saving]', sv);
      else if (n === q - 1) txt = say('dealLast', txt).replace('[count]', n).replace('[saving]', sv);
      else if (n > 0) txt = say('dealSome', txt).replace('[count]', n).replace('[left]', q - n).replace('[saving]', sv);
      out.textContent = txt;
      d.classList.toggle('is-on', n >= q);
    });
  }

  /* US bags: the real standard delivery rate for what's in the bag, from Shopify's rate lookup (US rates are flat
     across states, so a sample address is enough). Until it answers, or if it fails, the bag keeps its "from" line. */
  const usRates = {};
  async function usDelivery() {
    $$('[data-us-delivery]').forEach(async el => {
      const sig = el.dataset.sig;
      try {
        if (!(sig in usRates)) {
          usRates[sig] = fetch(`${routes.cart_url}/shipping_rates.json?shipping_address[country]=US&shipping_address[province]=NY&shipping_address[zip]=10001`, { headers: { Accept: 'application/json' } })
            .then(r => (r.ok ? r.json() : null)).catch(() => null);
        }
        const data = await usRates[sig];
        const prices = data && data.shipping_rates ? data.shipping_rates.map(r => Math.round(parseFloat(r.price) * 100)).filter(n => !isNaN(n)) : [];
        if (prices.length && el.isConnected) el.textContent = say('usBag', 'US delivery for this bag: [amount]. Checkout confirms it.').replace('[amount]', formatMoney(Math.min(...prices)));
      } catch { /* the "from" line stays */ }
    });
  }

  /* Wear it with: the bag renders cross-type picks itself; Shopify's complementary products for the first piece replace them when set */
  const recsCache = {};
  const recsFor = (pid, intent) => fetch(`${routes.product_recommendations_url}?product_id=${pid}&limit=8&section_id=bag-recs&intent=${intent}`).then(r => (r.ok ? r.text() : '')).catch(() => '');
  async function loadBagRecs() {
    const slot = drawer && $('[data-bag-recs]', drawer);
    const pid = slot && slot.dataset.productId;
    if (!pid) return;
    if (!(pid in recsCache)) {
      const P = window.OTC_PREVIEW;
      recsCache[pid] = P && P.bagRecs !== undefined ? Promise.resolve(P.bagRecs)
        : routes.product_recommendations_url
          ? recsFor(pid, 'complementary')
          : Promise.resolve('');
    }
    const html = await recsCache[pid];
    if (!slot.isConnected) return;
    const list = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bag-recs-list]');
    if (!list) return;
    const inBag = (slot.dataset.inCart || '').split(',');
    $$('[data-product-id]', list).forEach(el => { if (inBag.includes(el.dataset.productId) || el.hasAttribute('data-no-feature')) el.remove(); });
    // a cap in the bag suggests tees first, a tee suggests caps and the hoodie
    const types = (slot.dataset.types || '').split(',');
    const row = $('[data-product-id]', list) && $('[data-product-id]', list).parentElement;
    if (row) $$('[data-product-id]', list).filter(el => !types.includes(el.dataset.type)).reverse().forEach(el => row.prepend(el));
    $$('[data-product-id]', list).slice(3).forEach(el => el.remove());
    if (!$('[data-product-id]', list)) return;
    const kitLine = $('.pdp__kit', slot);
    slot.replaceChildren(list);
    if (kitLine) list.append(kitLine);
    slot.hidden = false;
  }
  async function add(items, busyEl) {
    busyEl && busyEl.classList.add('is-busy');
    try {
      const data = await backend().add(items);
      if (location.pathname === routes.cart_url) {
        try { sessionStorage.setItem('otcCartFocus', JSON.stringify({ v: String(items[0].id), d: 'plus' })); } catch (e) {}
        // replace, not reload: a reload restores the old scroll position and leaves the focused new line off screen
        location.replace(routes.cart_url); return;
      }
      renderDrawer(data.sections && data.sections['cart-drawer']); openDrawer();
    }
    catch (err) { toast(err.message); }
    finally { busyEl && busyEl.classList.remove('is-busy'); }
  }
  async function change(key, qty, busyEl) {
    // re-rendering replaces the line and Shopify issues new line keys, so focus is put back by variant, then by position
    const a = document.activeElement, dir = a && a.matches && a.matches('#CartDrawer button[data-qty]') ? a.dataset.qty : null;
    const vid = key.split(':')[0], idx = $$('[data-line]', drawer).findIndex(l => l.dataset.key === key);
    busyEl && busyEl.classList.add('is-busy');
    try {
      const data = await backend().change(key, qty);
      renderDrawer(data.sections && data.sections['cart-drawer']);
      if (a && drawer && !drawer.contains(a)) {
        const ls = $$('[data-line]', drawer), same = ls.find(l => l.dataset.key.split(':')[0] === vid), near = same || ls[Math.min(idx, ls.length - 1)];
        const back = (same && dir && $(`button[data-qty="${dir}"]`, same)) || (near && $('[data-remove]', near)) || $('[data-drawer-close]', drawer);
        back && back.focus();
      }
    } catch (err) { toast(err.message); busyEl && busyEl.classList.remove('is-busy'); }
  }

  document.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('[data-drawer-open]') && drawer) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]') || t.classList.contains('drawer-scrim')) { e.preventDefault(); closeDrawer(); return; }
    const q = t.closest('button[data-qty]');
    if (q) { const line = q.closest('[data-line]'); change(line.dataset.key, Math.max(0, Number(line.dataset.qty) + Number(q.dataset.qty)), line); return; }
    const rm = t.closest('[data-remove]');
    if (rm) { e.preventDefault(); const line = rm.closest('[data-line]'); change(line.dataset.key, 0, line); return; }
    const qa = t.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); add([{ id: Number(qa.dataset.quickAdd), quantity: 1 }], qa.closest('.qa')); return; }
    const qt = t.closest('[data-qa-toggle]');
    if (qt) { e.preventDefault(); const panel = qt.closest('.card').querySelector('.qa'); panel && panel.classList.toggle('is-open'); qt.setAttribute('aria-expanded', panel && panel.classList.contains('is-open')); return; }
    $$('[data-drop][open]').forEach(d => { if (!d.contains(t)) d.removeAttribute('open'); });
    const menuLink = t.closest('.menu__panel a');
    if (menuLink) { const d = menuLink.closest('details'); d && d.removeAttribute('open'); }
  });
  document.addEventListener('submit', e => {
    const f = e.target.closest('form[data-ajax-cart], form[action*="/cart/add"]');
    if (!f) return;
    e.preventDefault();
    const fd = new FormData(f);
    const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    // line item properties, e.g. a gift card's recipient (disabled fields aren't in the FormData)
    const props = {};
    for (const [k, v] of fd.entries()) { const m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; }
    if (Object.keys(props).length) item.properties = props;
    add([item], f.querySelector('[type="submit"]'));
  });
  // the cart page's −/+ and Remove reload the page, so put focus back on the same control (line keys change, variants don't)
  const cartForm = $('.cart-page__grid');
  if (cartForm) {
    const keep = el => { try { sessionStorage.setItem('otcCartFocus', JSON.stringify({ v: el.dataset.variant, d: el.dataset.dir, i: $$('.line', cartForm).indexOf(el.closest('.line')) })); } catch (e) {} };
    cartForm.addEventListener('submit', e => { const b = e.submitter; if (b && b.dataset.dir) keep(b); });
    $$('.line__remove', cartForm).forEach(a => a.addEventListener('click', () => keep(a)));
  }
  if (location.pathname === routes.cart_url) {
    let was = null;
    try { was = JSON.parse(sessionStorage.getItem('otcCartFocus') || 'null'); sessionStorage.removeItem('otcCartFocus'); } catch (e) {}
    if (was) {
      const pg = $('main') || document;
      const rms = $$('.line__remove', pg);
      const to = $(`[data-variant="${was.v}"][data-dir="${was.d}"]`, pg) || (rms.length && rms[Math.min(Math.max(was.i, 0), rms.length - 1)]) || $('[name="checkout"]', pg) || $('.drawer__empty .btn', pg);
      if (to) to.focus({ focusVisible: true });
    }
  }
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (document.body.classList.contains('drawer-open')) closeDrawer();
    const m = $('.menu[open]'); m && m.removeAttribute('open');
    $$('[data-drop][open]').forEach(d => { d.removeAttribute('open'); $('summary', d).focus(); });
  });
  $$('[data-drop]').forEach(d => {
    d.addEventListener('mouseenter', () => { if (finePointer.matches) d.open = true; });
    d.addEventListener('mouseleave', () => { if (finePointer.matches) d.open = false; });
    // hover already opened it, so a mouse click shouldn't close it again; keyboard toggling still works
    $('summary', d).addEventListener('click', e => { if (finePointer.matches && d.open && e.detail > 0) e.preventDefault(); });
  });

  /* product page: gallery */
  function initGallery(el) {
    const gal = $('[data-gallery]', el);
    if (!gal) return null;
    const track = $('.gal__track', gal), slides = $$('.gal__slide', gal), thumbs = $$('.gal__thumb', gal);
    const dots = $('.gal__dots', gal), views = $('.gal__views', gal), idxEl = $('[data-gal-index]', gal), totEl = $('[data-gal-total]', gal);
    const prev = $('[data-gal-prev]', gal), next = $('[data-gal-next]', gal);
    const NAME = { back: say('viewBack', 'Back'), front: say('viewFront', 'Front'), detail: say('viewDetail', 'Close-up') };
    let list = slides.slice(), cur = 0;
    const slideFor = id => slides.find(s => s.dataset.mediaId === String(id));

    function mark() {
      slides.forEach(s => s.classList.remove('is-zoom'));
      thumbs.forEach(t => t.setAttribute('aria-current', slideFor(t.dataset.target) === list[cur]));
      $$('i', dots).forEach((d, i) => d.classList.toggle('is-on', i === cur));
      $$('button', views).forEach((b, i) => b.setAttribute('aria-current', i === cur));
      if (idxEl) idxEl.textContent = cur + 1;
      if (prev) prev.disabled = cur === 0;
      if (next) next.disabled = cur === list.length - 1;
      const t = thumbs.find(x => x.getAttribute('aria-current') === 'true');
      if (t && t.parentElement.scrollHeight > t.parentElement.clientHeight) t.scrollIntoView({ block: 'nearest' });
    }
    function go(i, smooth = true) {
      cur = Math.max(0, Math.min(list.length - 1, i));
      const s = list[cur];
      if (s) track.scrollTo({ left: s.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      mark();
    }
    // show only this fit and colour's photos, in the order set in Shopify admin; photos with no colour or fit show for every one
    function setView(color, fit, preferId) {
      const c = (color || '').toLowerCase(), f = (fit || '').toLowerCase();
      const byFit = slides.filter(s => !s.dataset.fit || s.dataset.fit === f);
      let pick = byFit.filter(s => !s.dataset.color || s.dataset.color === c);
      if (!pick.some(s => s.dataset.color)) pick = byFit.some(s => s.dataset.fit) ? byFit : slides.slice();
      list = pick;
      slides.forEach(s => { const i = list.indexOf(s); s.hidden = i < 0; s.style.order = i; });
      thumbs.forEach(t => { const i = list.indexOf(slideFor(t.dataset.target)); t.hidden = i < 0; t.style.order = i; });
      if (dots) dots.innerHTML = list.length > 1 ? list.map(() => '<i></i>').join('') : '';
      const roles = list.map(s => s.dataset.role);
      if (views) views.innerHTML = list.length > 1 && new Set(roles).size === roles.length ? list.map((s, i) => `<button type="button" data-view="${i}">${NAME[s.dataset.role] || i + 1}</button>`).join('') : '';
      if (totEl) totEl.textContent = list.length;
      list.slice(0, 2).forEach(sl => { const im = $('img', sl); if (im) im.loading = 'eager'; });
      const start = preferId ? Math.max(0, list.indexOf(slideFor(preferId))) : 0;
      requestAnimationFrame(() => go(start, false));
    }
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur && list[i]) { cur = i; mark(); }
      });
    }, { passive: true });
    prev && prev.addEventListener('click', () => go(cur - 1));
    next && next.addEventListener('click', () => go(cur + 1));
    thumbs.forEach(t => t.addEventListener('click', () => go(list.indexOf(slideFor(t.dataset.target)))));
    views && views.addEventListener('click', e => { const b = e.target.closest('[data-view]'); if (b) go(Number(b.dataset.view)); });
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      if (e.key === 'Enter') { e.preventDefault(); openLb(cur); }
    });
    // hover to magnify on desktop, click for full screen
    track.addEventListener('mousemove', e => {
      if (!finePointer.matches) return;
      const s = e.target.closest('.gal__slide');
      if (!s) return;
      const r = s.getBoundingClientRect();
      s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      s.classList.add('is-zoom');
    });
    track.addEventListener('mouseleave', () => slides.forEach(s => s.classList.remove('is-zoom')));
    track.addEventListener('click', e => { if (e.target.closest('.gal__slide')) openLb(cur); });
    const openBtn = $('[data-gal-open]', gal);
    openBtn && openBtn.addEventListener('click', () => openLb(cur));

    // full-screen viewer
    const lb = $('[data-lightbox]', el), lbImg = lb && $('[data-lb-img]', lb), lbStage = lb && $('[data-lb-stage]', lb), lbCount = lb && $('[data-lb-count]', lb);
    let li = 0, sx = null;
    function drawLb() {
      const s = list[li];
      if (!s) return;
      const img = $('img', s);
      lbImg.src = s.dataset.zoom || (img && img.currentSrc) || '';
      lbImg.alt = img ? img.alt : '';
      lbCount.textContent = `${li + 1} / ${list.length}`;
      lbStage.classList.remove('is-zoomed');
    }
    function openLb(i) {
      if (!lb || !list.length) return;
      li = i; drawLb();
      if (!lb.open) lb.showModal();
    }
    if (lb) {
      const step = d => { li = (li + d + list.length) % list.length; drawLb(); };
      $('[data-lb-prev]', lb).addEventListener('click', () => step(-1));
      $('[data-lb-next]', lb).addEventListener('click', () => step(1));
      $('[data-lb-close]', lb).addEventListener('click', () => lb.close());
      lb.addEventListener('close', () => go(li, false));
      lb.addEventListener('keydown', e => { if (e.key === 'ArrowRight') step(1); if (e.key === 'ArrowLeft') step(-1); });
      const origin = e => { const r = lbImg.getBoundingClientRect(); lbStage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%'); lbStage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'); };
      lbStage.addEventListener('click', e => { if (e.target !== lbImg) return; origin(e); lbStage.classList.toggle('is-zoomed'); });
      lbStage.addEventListener('mousemove', e => { if (lbStage.classList.contains('is-zoomed')) origin(e); });
      lbStage.addEventListener('pointerdown', e => { sx = e.clientX; });
      lbStage.addEventListener('pointerup', e => {
        if (sx === null || lbStage.classList.contains('is-zoomed')) { sx = null; return; }
        const dx = e.clientX - sx; sx = null;
        if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
      });
    }
    return { setView };
  }

  /* product page: options, size choice, price, delivery dates, buy bar */
  function initProduct(el) {
    const json = $('[data-product-json]', el);
    if (!json || el.dataset.ready) return;
    el.dataset.ready = '1';
    const product = JSON.parse(json.textContent);
    const form = $('form[data-ajax-cart], form[action*="/cart/add"]', el), idInput = form && $('input[name="id"]', form);
    const price = $('[data-price]', el), compare = $('[data-compare]', el);
    const btn = $('[data-atc]', el), label = $('[data-atc-label]', el), hint = $('[data-size-hint]', el);
    const sets = $$('fieldset[data-option-index]', el);
    const sizeIdx = product.options.findIndex(o => /size/i.test(o));
    const colorIdx = product.options.findIndex(o => /colou?r/i.test(o));
    const fitIdx = product.options.findIndex(o => !/size|colou?r/i.test(o) && /fit|style|cut/i.test(o));
    const setFor = i => sets.find(fs => Number(fs.dataset.optionIndex) === i);
    const sizeSet = setFor(sizeIdx);
    const wrap = el.parentElement, sticky = wrap && $('[data-sticky]', wrap);
    const gallery = initGallery(el);
    let sizeChosen = el.dataset.sizeChosen === 'true' || sizeIdx < 0;
    let variant = null;

    const picked = () => product.options.map((_, i) => { const fs = sets.find(s => Number(s.dataset.optionIndex) === i); const c = fs && $('input:checked', fs); return c ? c.value : null; });
    const find = opts => product.variants.find(v => v.options.every((o, i) => opts[i] == null || o === opts[i]));

    // a fit can come in fewer colours and sizes: hide the ones it isn't made in, and move off a hidden choice
    function fitOnly() {
      if (fitIdx < 0) return;
      const fit = picked()[fitIdx];
      const inFit = product.variants.filter(v => v.options[fitIdx] === fit);
      sets.forEach(fs => {
        const i = Number(fs.dataset.optionIndex);
        if (i === fitIdx) return;
        $$('input', fs).forEach(inp => {
          const made = inFit.some(v => v.options[i] === inp.value);
          inp.disabled = !made;
          if (inp.nextElementSibling) inp.nextElementSibling.hidden = !made;
        });
        const cur = $('input:checked', fs);
        if (cur && !cur.disabled) return;
        if (cur) cur.checked = false;
        if (i === sizeIdx) sizeChosen = false;
        else { const first = $$('input', fs).find(x => !x.disabled); if (first) first.checked = true; }
      });
    }

    function update(colorChanged, initial) {
      fitOnly();
      const opts = picked();
      variant = find(opts);
      const note = $('[data-fit-note]', el);
      if (note) { const lab = $('input:checked + .opt__fit', setFor(fitIdx)); note.textContent = lab && lab.dataset.note || ''; note.hidden = !note.textContent; }
      sets.forEach(fs => {
        const i = Number(fs.dataset.optionIndex), out = $('[data-option-value]', fs);
        if (out) out.textContent = i === sizeIdx && !sizeChosen ? '' : (opts[i] || '');
      });
      if (sizeIdx > -1) $$('input', sizeSet).forEach(inp => {
        const test = opts.slice(); test[sizeIdx] = inp.value;
        const tv = find(test);
        inp.nextElementSibling.classList.toggle('is-unavailable', !tv || !tv.available);
      });
      const v = variant;
      if (v) {
        if (idInput) idInput.value = v.id;
        if (price) price.textContent = formatMoney(v.price);
        if (compare) compare.textContent = compare.dataset.was || (v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '');
      }
      let text, disabled = false;
      if (!v) { text = say('unavailable', 'Unavailable'); disabled = true; }
      else if (!v.available && sizeChosen) { text = say('soldOut', 'Sold out'); disabled = true; }
      else if (!sizeChosen) text = say('selectSize', 'Select a size');
      else text = say('addPrice', 'Add to bag · [price]').replace('[price]', formatMoney(v.price));
      if (btn) btn.disabled = disabled;
      if (label) label.textContent = text;
      if (sticky) {
        const sel = [fitIdx > -1 ? opts[fitIdx] : null, colorIdx > -1 ? opts[colorIdx] : null, sizeIdx > -1 ? (sizeChosen ? opts[sizeIdx] : say('selectSize', 'Select a size')) : null].filter(Boolean).join(' · ');
        $('[data-sticky-sel]', sticky).textContent = sel;
        if (v) $('[data-sticky-price]', sticky).textContent = formatMoney(v.price);
        const sb = $('[data-sticky-btn]', sticky);
        sb.textContent = !sizeChosen ? say('chooseSize', 'Choose size') : disabled ? text : say('addToCart', 'Add to bag');
        sb.disabled = disabled && sizeChosen;
      }
      if (colorChanged && gallery) gallery.setView(colorIdx > -1 ? opts[colorIdx] : '', fitIdx > -1 ? opts[fitIdx] : '', !initial && v && v.featured_media && v.featured_media.id);
      if (sizeChosen && v && !window.OTC_PREVIEW && history.replaceState) history.replaceState(null, '', `${location.pathname}?variant=${v.id}`);
    }
    function askForSize() {
      if (!sizeSet) return;
      hint.hidden = false;
      sizeSet.classList.remove('is-shake'); void sizeSet.offsetWidth; sizeSet.classList.add('is-shake');
      sizeSet.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      const first = $('input', sizeSet);
      first && first.focus({ preventScroll: true });
    }
    el.addEventListener('change', e => {
      const fs = e.target.closest('fieldset[data-option-index]');
      if (!fs) return;
      const i = Number(fs.dataset.optionIndex);
      if (i === sizeIdx) { sizeChosen = true; if (hint) hint.hidden = true; }
      update(i === colorIdx || i === fitIdx);
    });
    // a link with ?option_values= (from a fit collection) picks the fit and colour but leaves the size to the shopper
    function select(ids) {
      ids.forEach(id => { const inp = $(`input[data-value-id="${id}"]`, el); if (inp) inp.checked = true; });
      if (sizeSet) { $$('input', sizeSet).forEach(i => { i.checked = false; }); sizeChosen = false; }
    }
    const q = new URLSearchParams(location.search);
    if (q.get('option_values') && !q.get('variant')) select(q.get('option_values').split(','));
    el.addEventListener('otc:select', e => { select(e.detail || []); update(true); });
    // the page's own submit check runs before the bag handler and stops it until a size is chosen
    form && form.addEventListener('submit', e => { if (!sizeChosen) { e.preventDefault(); e.stopPropagation(); askForSize(); } });
    // express checkout (Shop Pay, Apple Pay) skips the submit, so it gets the same check before its own click handler
    const express = $('[data-express]', el);
    express && express.addEventListener('click', e => { if (!sizeChosen) { e.preventDefault(); e.stopPropagation(); askForSize(); } }, true);
    update(true, true);

    if (sticky && btn) {
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting)).observe(btn);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => { if (!sizeChosen) askForSize(); else btn.click(); });
    }

    // size guide
    const sg = $('[data-size-guide]', el);
    if (sg) {
      const fits = $$('[data-sg-fit]', sg), tabs = $$('[data-sg-tab]', sg);
      const showFit = f => {
        const hit = fits.find(x => x.dataset.sgFit === f) || fits[0];
        fits.forEach(x => { x.hidden = x !== hit; });
        tabs.forEach(t => t.setAttribute('aria-pressed', hit && t.dataset.sgTab === hit.dataset.sgFit));
      };
      tabs.forEach(t => t.addEventListener('click', () => showFit(t.dataset.sgTab)));
      $$('[data-size-guide-open]', el).forEach(b => b.addEventListener('click', () => {
        showFit(fitIdx > -1 ? String(picked()[fitIdx] || '').toLowerCase().trim() : '');
        sg.showModal();
      }));
      $('[data-size-guide-close]', sg).addEventListener('click', () => sg.close());
      sg.addEventListener('click', e => { if (e.target === sg) sg.close(); });
    }

    // the chosen size's garment measurements, under the size buttons and highlighted in the charts
    const gjson = $('[data-garment]', el), readout = $('[data-measure]', el);
    let garment = null;
    try { garment = gjson ? JSON.parse(gjson.textContent) : null; } catch (e) { garment = null; }
    const fmt = v => {
      if (v == null || v === '') return null;
      if (root.dataset.units !== 'in') return v + ' cm';
      const h = Math.round(v * 2 / 2.54); return (h / 2) + ' in';
    };
    function measure() {
      const size = sizeIdx > -1 && sizeChosen ? picked()[sizeIdx] : null;
      $$('[data-gchart] tr[data-size]', el).forEach(tr => tr.classList.toggle('is-picked', tr.dataset.size === size));
      if (!readout || !garment) return;
      const i = size ? garment.sizes.indexOf(size) : -1;
      const parts = i < 0 ? [] : garment.rows.map(r => { const v = fmt(r.values[i]); return v && `${r.label} ${v}`; }).filter(Boolean);
      readout.hidden = !parts.length;
      readout.textContent = parts.length ? say('measureLine', '[size]: [list]').replace('[size]', size).replace('[list]', parts.join(' · ')) : '';
    }
    el.addEventListener('change', measure);
    document.addEventListener('otc:units', measure);
    measure();
    if (sg) sg.addEventListener('click', e => {
      const b = e.target.closest('[data-sg-pick], tr[data-size]');
      if (!b || !sizeSet) return;
      const want = b.dataset.sgPick || b.dataset.size;
      const inp = $$('input', sizeSet).find(x => x.value === want && !x.disabled);
      if (!inp) return;
      inp.checked = true;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      sg.close();
    });

    // delivery estimate: today plus working days, skipping weekends and bank holidays
    const eta = $('[data-eta]', el);
    if (eta) {
      const dateLang = window.Shopify && Shopify.country === 'US' ? 'en-US' : 'en-GB';
      // England and Wales bank holidays for UK shoppers; US federal holidays for the US
      const HOL = dateLang === 'en-US' ? ['2026-11-11', '2026-11-26', '2026-12-25', '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-06-18', '2027-07-05', '2027-09-06', '2027-10-11', '2027-11-11', '2027-11-25', '2027-12-24', '2027-12-31'] : ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];
      const ymd = d => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      const add = n => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6 && !HOL.includes(ymd(d))) k++; } return d; };
      const fmt = d => d.toLocaleDateString(dateLang, { weekday: 'short', day: 'numeric', month: 'short' });
      $('[data-eta-dates]', eta).textContent = say('etaArrives', 'Arrives {from} to {to}').replace('{from}', fmt(add(Number(eta.dataset.min)))).replace('{to}', fmt(add(Number(eta.dataset.max))));
    }
  }


  async function initRecs(el) {
    if (el.dataset.loaded || !el.dataset.url || el.children.length) return;
    el.dataset.loaded = '1';
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
      if (fresh) {
        const skip = (el.dataset.skip || '').split(',');
        $$('[data-card-id]', fresh).forEach(c => { if (skip.includes(c.dataset.cardId) || c.hasAttribute('data-no-feature')) c.remove(); });
        $$('[data-card-id]', fresh).slice(4).forEach(c => c.remove());
      }
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML; else el.closest('.recs') && (el.closest('.recs').hidden = true);
    } catch { /* recommendations are optional */ }
  }

  /* "you are here": the hour that matches the shopper's own clock */
  function markLive() {
    const hours = $$('[data-hour]');
    if (!hours.length) return;
    const d = new Date(), now = d.getHours() * 60 + d.getMinutes();
    const start = t => { const m = /(\d{1,2}):(\d{2})/.exec(t || ''); return m ? hour24(t) * 60 + Number(m[2]) : Infinity; };
    let live = -1;
    hours.forEach((h, i) => { if (start(h.dataset.time) <= now) live = i; });
    const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
    hours.forEach((h, i) => {
      const chip = $('[data-live]', h);
      if (!chip) return;
      chip.hidden = i !== live;
      if (i === live) chip.textContent = say('youAreHere', 'You are here · [time]').replace('[time]', time);
    });
    stops.forEach((s, i) => s.classList.toggle('is-live', i === live));
  }

  /* the big time rolls into place like a departure board, and the stats count up, as each hour scrolls in */
  const DIGITS = '01234567890123456789'.split('').map(n => `<span>${n}</span>`).join('');
  const seen = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(e => {
    if (!e.isIntersecting) return;
    seen.unobserve(e.target);
    if (e.target.matches('[data-roll]')) e.target.classList.add('is-rolled');
    else $$('[data-stat]', e.target).forEach(countUp);
  }), { rootMargin: '0px 0px -15% 0px' }) : null;
  function initRoll(el) {
    if (el.dataset.rollOn) return;
    const txt = el.textContent.trim();
    if (!/^\d{1,2}:\d{2}$/.test(txt)) return;
    el.dataset.rollOn = '1';
    el.innerHTML = [...txt].map((ch, i) => ch === ':'
      ? '<span class="roll roll--sep"><span class="roll__strip"><span>:</span></span></span>'
      : `<span class="roll" style="--d:${ch};--i:${i}"><span class="roll__strip">${DIGITS}</span></span>`).join('');
    if (reduce || !seen) el.classList.add('is-rolled'); else seen.observe(el);
  }
  const countable = dd => /^(\d[\d,]*)(.*)$/.exec(dd.dataset.final || '');
  function countUp(dd) {
    const m = countable(dd);
    if (!m) return;
    const target = Number(m[1].replace(/,/g, '')), comma = m[1].includes(','), t0 = performance.now();
    const step = now => {
      const p = Math.min(1, (now - t0) / 1300), v = Math.round(target * (1 - (1 - p) ** 3));
      dd.textContent = (comma ? v.toLocaleString('en-GB') : v) + m[2];
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  function initStats(el) {
    if (el.dataset.on) return;
    el.dataset.on = '1';
    if (reduce || !seen) return;
    // big numbers start at zero and count up once the row is on screen
    $$('[data-stat]', el).forEach(dd => {
      dd.dataset.final = dd.textContent.trim();
      const m = countable(dd);
      if (m && Number(m[1].replace(/,/g, '')) >= 10) dd.textContent = '0' + m[2]; else delete dd.dataset.final;
    });
    seen.observe(el);
  }

  /* What hour are you? The results are the Hour sections on the page: their times, words, colors and shop links. */
  function initQuiz(el) {
    if (el.dataset.on) return;
    el.dataset.on = '1';
    const qs = $$('[data-quiz-q]', el), result = $('[data-quiz-result]', el);
    const hours = $$('[data-hour]').map(h => ({
      time: h.dataset.time, label: h.dataset.label, sky: h.dataset.sky, ink: h.dataset.ink, spark: h.dataset.spark || '',
      sparkInk: getComputedStyle(h).getPropertyValue('--spark-ink').trim(),
      name: ($('.hour__name', h) || {}).textContent || h.dataset.label,
      blurb: ($('.hour__blurb', h) || {}).textContent || '',
      link: ($('.hour__cta', h) || {}).href || '#' + h.id
    }));
    if (!qs.length || !hours.length || !result) { el.hidden = true; return; }
    // Result blocks: the read for an hour, its role in the group chat, and the hour to ride with
    const reads = $$('[data-quiz-read]', el).map(r => ({ hour: Number(r.dataset.quizRead), read: r.textContent.trim(), role: r.dataset.role || '', match: Number(r.dataset.match) || 0, note: r.dataset.note || '' }));
    let step = 0, score = [], last = 0, picked = null;
    const show = i => {
      qs.forEach((q, k) => { q.hidden = k !== i; });
      const first = qs[i] && $('[data-quiz-hour]', qs[i]);
      if (first && el.contains(document.activeElement)) first.focus({ preventScroll: true });
    };
    const paint = h => {
      [['--quiz-bg', h && h.sky], ['--quiz-ink', h && h.ink], ['--spark', h && h.spark], ['--spark-ink', h && h.sparkInk]]
        .forEach(([k, v]) => (v ? el.style.setProperty(k, v) : el.style.removeProperty(k)));
      el.classList.toggle('is-result', !!h);
    };
    function finish() {
      const top = Math.max(...hours.map((_, i) => score[i] || 0));
      // a tie goes to the hour of the last answer if it's one of them, otherwise the earliest
      const best = (score[last] || 0) === top ? last : hours.findIndex((_, i) => (score[i] || 0) === top);
      picked = hours[best];
      qs.forEach(q => { q.hidden = true; });
      const time = $('[data-quiz-time]', result);
      time.textContent = picked.time;
      delete time.dataset.rollOn;
      time.classList.remove('is-rolled');
      $('[data-quiz-name]', result).textContent = picked.name;
      const read = reads.find(r => r.hour === best + 1);
      $('[data-quiz-blurb]', result).textContent = (read && read.read) || picked.blurb;
      const facts = $('[data-quiz-facts]', result);
      if (facts) {
        const role = read ? read.role : '', mate = read && read.match && read.match - 1 !== best ? hours[read.match - 1] : null;
        $('[data-quiz-role-row]', facts).hidden = !role;
        $('[data-quiz-role]', facts).textContent = role;
        $('[data-quiz-match-row]', facts).hidden = !mate;
        if (mate) {
          const a = $('[data-quiz-match]', facts);
          a.textContent = `${mate.time} ${mate.label}`;
          a.href = mate.link;
          $('[data-quiz-note]', facts).textContent = read.note;
        }
        facts.hidden = !role && !mate;
      }
      const shop = $('[data-quiz-shop]', result);
      shop.href = picked.link;
      shop.textContent = say('quizShop', 'Shop your hour').replace('[hour]', picked.label);
      const signup = $('[data-quiz-signup]', result);
      if (signup) signup.textContent = (signup.dataset.tpl || '').replace('[time]', picked.time);
      const tags = $('[data-quiz-tags]', result);
      if (tags) tags.value = `quiz, quiz ${picked.time}`;
      paint(picked);
      result.hidden = false;
      initRoll(time);
      $('[data-quiz-name]', result).setAttribute('tabindex', '-1');
      $('[data-quiz-name]', result).focus({ preventScroll: true });
      el.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    }
    el.addEventListener('click', e => {
      const a = e.target.closest('[data-quiz-hour]');
      if (a && step < qs.length) {
        const h = Math.min(hours.length, Math.max(1, Number(a.dataset.quizHour) || 1)) - 1;
        score[h] = (score[h] || 0) + 1; last = h;
        a.classList.add('is-picked');
        setTimeout(() => { step++; if (step < qs.length) show(step); else finish(); }, reduce ? 0 : 260);
        return;
      }
      if (e.target.closest('[data-quiz-retake]')) {
        step = 0; score = []; picked = null;
        $$('.is-picked', el).forEach(b => b.classList.remove('is-picked'));
        result.hidden = true; paint(null); show(0);
        return;
      }
      if (e.target.closest('[data-quiz-share]') && picked) {
        const text = say('quizShare', "apparently i'm [time]. what hour are you?").replace('[time]', picked.time).replace('[hour]', picked.label);
        const url = location.origin + location.pathname + '#quiz';
        if (navigator.share) navigator.share({ text, url }).catch(() => {});
        else if (navigator.clipboard) navigator.clipboard.writeText(`${text} ${url}`).then(() => toast(say('linkCopied', 'Link copied.')), () => {});
      }
    });
  }

  /* shop by hour: tabs that swap the products underneath (arrow keys move between hours) */
  function initHours(el) {
    if (el.dataset.on) return;
    el.dataset.on = '1';
    const tabs = $$('[role="tab"]', el), list = $('.rail__list', el);
    const pick = (t, focus) => {
      tabs.forEach(x => {
        const on = x === t;
        x.setAttribute('aria-selected', String(on));
        x.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(x.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) t.focus({ preventScroll: true });
      // on small screens the hours scroll sideways: bring the picked one into view without moving the page
      if (list && list.scrollWidth > list.clientWidth) list.scrollTo({ left: t.parentElement.offsetLeft - (list.clientWidth - t.parentElement.offsetWidth) / 2, behavior: reduce || !focus ? 'auto' : 'smooth' });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => pick(t, true));
      t.addEventListener('keydown', e => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        pick(tabs[(i + d + tabs.length) % tabs.length], true);
      });
    });
    // open on the hour it is right now in the park
    const n = parkNow();
    const now = tabs.filter(t => Number(t.parentElement.dataset.start) <= n.mins).pop();
    if (now && n.hour) pick(now, false);
  }

  /* every day line gets a dot for the time right now; the hour it falls in is marked. The hero and Shop by hour say it in words. */
  function markNow() {
    const n = parkNow();
    $$('[data-rail]').forEach(r => {
      const stops = $$('.rail__stop', r), dot = $('[data-rail-now]', r);
      const cur = n.hour ? stops.filter(s => Number(s.dataset.start) <= n.mins).pop() : null;
      stops.forEach(s => s.classList.toggle('is-now', s === cur));
      if (!dot) return;
      const x = (n.mins - 480) / 930 * 100;
      dot.hidden = !(n.hour && x >= 0 && x <= 100);
      if (!dot.hidden) { dot.style.setProperty('--x', x.toFixed(2) + '%'); $('[data-rail-now-text]', dot).textContent = say('railNow', 'now [time]').replace('[time]', n.time); }
    });
    const words = n.hour ? say('nowHour', 'now [time] · [hour]').replace('[time]', n.time).replace('[hour]', n.hour.name)
      : PARK.length ? say('parkShut', "park's closed. gates at [time]").replace('[time]', PARK[0].time) : '';
    $$('[data-park-status], [data-hero-now]').forEach(x => {
      const out = $('[data-hero-now-text]', x) || x;
      out.textContent = words;
      x.hidden = !words;
      x.classList.toggle('is-closed', !n.hour);
    });
  }

  /* cm or inches, for every size chart and measurement; remembered for next time */
  function setUnits(u, save) {
    root.dataset.units = u === 'in' ? 'in' : 'cm';
    $$('[data-units-set]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.unitsSet === root.dataset.units)));
    if (save) { try { localStorage.setItem('otc-units', root.dataset.units); } catch (e) { /* private mode */ } }
    document.dispatchEvent(new CustomEvent('otc:units'));
  }
  document.addEventListener('click', e => { const b = e.target.closest('[data-units-set]'); if (b) setUnits(b.dataset.unitsSet, true); });
  (() => { let u = 'cm'; try { u = localStorage.getItem('otc-units') || 'cm'; } catch (e) { /* private mode */ } setUnits(u); })();

  /* collection sort and filters */
  document.addEventListener('change', e => {
    const s = e.target.closest('[data-sort]');
    if (s) { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u.toString(); }
    const f = e.target.closest('form[data-filters]');
    if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
    // footer country switch: Shopify's localization form reloads the page for that country
    const c = e.target.closest('[data-country]');
    if (c && c.form) c.form.submit();
  });

  /* gift card: price on the button, and the optional recipient form */
  function initGiftCard(el) {
    const price = $('[data-gc-price]', el), send = $('[data-gc-send]', el), box = $('[data-gc-recipient]', el), off = $('[data-gc-offset]', el);
    el.addEventListener('change', e => {
      if (e.target.name === 'id' && price) price.textContent = e.target.dataset.price;
      if (e.target === send && box) { box.disabled = !send.checked; box.hidden = !send.checked; if (send.checked) { const em = $('input[type="email"]', box); em && em.focus(); } }
    });
    if (off) off.value = new Date().getTimezoneOffset().toString();
  }

  function init() {
    initDay();
    $$('[data-gc]').forEach(initGiftCard);
    markLive();
    $$('[data-roll]').forEach(initRoll);
    $$('.stats').forEach(initStats);
    $$('[data-quiz]').forEach(initQuiz);
    $$('[data-hours]').forEach(initHours);
    markNow();
    dealText();
    if (location.pathname === routes.cart_url) usDelivery();
    $$('.deco-fireworks canvas').forEach(fireworks);
    $$('[data-product]').forEach(initProduct);
    $$('[data-recs][data-url]').forEach(initRecs);
    if (!shown($('[data-hero]'))) localClock();
  }
  init();
  setInterval(() => { if (!shown($('[data-hero]'))) localClock(); markLive(); markNow(); }, 30000);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
  window.OTC = Object.assign(window.OTC || {}, { formatMoney, toast, openDrawer, closeDrawer, renderDrawer });
})();
